import { createContext } from 'react';
import type { Chat, ChatHistory } from '@trinity/chat';

type ChatHistoryItemContextValue = {
  isActive: boolean;
  item: Chat.Instance;
};

type FetchMoreHistoryContextValue = () => void;

type ChatHistoryManagerContextValue = {
  mode: ChatHistory.Mode;
  cursor: number;
  hasMore: boolean;
  loading: boolean;
  initialized: boolean;
};

type ChatHistoryFilterContextValue = {
  filter: 'all' | 'bookmarked' | 'profile';
  setFilter: (value: 'all' | 'bookmarked' | 'profile') => void;
  name: string;
  setName: (value: string) => void;
};

type ChatTabsContextValue = {
  index: number;
  items: Array<{
    id: number | null;
    identifier: string;
    name: string;
  }>;
};

type ChatHistoryOpenMenuContextValue = {
  openMenuId: string | null;
  setOpenMenuId: (id: string | null) => void;
};

// type ChatHistoryContextMenuVisibilityContextValue = [boolean, Dispatch<SetStateAction<boolean>>];

export const ChatHistoryItemsContext = createContext<Chat.Instance[]>(null);
export const ChatHistorySharedContext = createContext<Chat.Instance[]>(null);
export const ChatHistoryItemContext = createContext<ChatHistoryItemContextValue>(null);
export const FetchMoreHistoryContext = createContext<FetchMoreHistoryContextValue>(null);
export const ChatHistoryManagerContext = createContext<ChatHistoryManagerContextValue>(null);
export const ChatHistoryOpenMenuContext = createContext<ChatHistoryOpenMenuContextValue>(null);
// export const ChatHistoryContextMenuVisibilityContext = createContext<ChatHistoryContextMenuVisibilityContextValue>(null);

export const ChatHistoryFilterContext = createContext<ChatHistoryFilterContextValue>(null);

export const ChatTabsContext = createContext<ChatTabsContextValue>(null);